import { render, staticRenderFns } from "./ResumeHome.vue?vue&type=template&id=2cfd520f&"
import script from "./ResumeHome.vue?vue&type=script&lang=js&"
export * from "./ResumeHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports